import { defaultTableSettings, eventsTabDefault } from './default-table-settings';
import { COLUMN_FORMAT } from '../constants/column-format.const';
import { WIDGET_DEFINITION } from '../constants/widget-definition.const';
import { ICON } from '../constants/icon.const';
import { BUTTON_COLOR } from '../constants/button-color.const';

/**
 * Table Definition for People (Contracts) Table
 */
const contractRegionsTableInitialSettings = {
  ...defaultTableSettings,
  itemCaption: 'Contract Region',
  initialFormFocusFieldName: 'first',

  baseRoute: '/contract-region',
  // baseQueryString: 'with[]=region',

  /**
   * Reset the local storage settings if they were stored with any of these app versions
   * Add application version numbers to this list (make sure it is a PREVIOUS application
   * version number which reflects a now invalid set of settings)
   */
  resetForAppVersion: [
    '2.1.6',
    '2.7.9',
  ],

  /**
   * Definition of presets for the table columns
   */
  columnPresets: [
    {
      name: 'default',
      title: 'Default Fields',
      fields: [
        'id',
        'name',
        'description',
      ],
    },
    {
      name: 'tiny',
      title: 'Tiny',
      fields: [
        'id',
        'name',
        'description',
      ],
    },
    {
      name: 'all',
      title: 'All Fields',
      fields: [
        'id',
        'name',
        'description',
      ],
    },
  ],

  /**
   * Definition of columns and APIPolyForm fields for this table
   */
  columns: [
    {
      name: 'id',
      title: 'Identity',
      description: 'Contract Unique Identifier',
      format: COLUMN_FORMAT.ID_LINK,
      linkRoute: '/service-and-support/admin/contract-regions',
      visible: true,
      showInForm: false,
      order: 10,
      formOrder: 10,
    }, {
      name: 'name',
      title: 'Name',
      visible: true,
      order: 20,
      formOrder: 20,
    }, {
      name: 'description',
      title: 'Description',
      visible: true,
      order: 30,
      formOrder: 30,
    },
  ],

  /**
   * Possible actions
   */
  possibleActions: [
    {
      name: 'create',
      title: 'Add a Contract Region',
      color: BUTTON_COLOR.PRIMARY,
      icon: ICON.ADD,
      description: 'Create a new Contract Region',
      successMessage: 'Created',
      failMessage: 'Failed to Create',
      hideRecordActionButton: true,
    },
    {
      name: 'update',
      title: 'Edit',
      color: BUTTON_COLOR.PRIMARY,
      icon: ICON.EDIT,
      description: 'This will update the contract Region',
      successMessage: 'Updated contracts',
      failMessage: 'Failed to update Contract Region',
      hideRecordActionButton: true,
    },
    {
      name: 'delete',
      title: 'Delete',
      color: BUTTON_COLOR.DANGER,
      icon: ICON.DELETE,
      description: 'This will DELETE the Contract Region',
      successMessage: 'Contract deleted',
      failMessage: 'Failed to delete Contract Region',
      hideRecordActionButton: true,
    },
  ],

  /**
   *  Definition of Tab Groups for this table
   */
  tabs: [
    {
      name: 'detail',
      title: 'Details',
      description: 'Contract\'s Details',
      widgetDefinition: WIDGET_DEFINITION.ROW_DETAILS,
    },
    {
      ...eventsTabDefault,
      description: "Contract Region's Event Audit Trail",
    },
  ],
};

export default contractRegionsTableInitialSettings;
